// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"4701d00d","453":"61805fc5"}[chunkId] + ".chunk.js";
};